import React, { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { AutoImage } from '../components/auto-image'
import { BannerImage } from '../components/banner-image'
import { BlogSection } from '../components/blog-section'
import { ContentContainer } from '../components/content-container'
import { DecoratedFrame } from '../components/decorated-frame'
import { HeadBannar } from '../components/head-bannar'
import { Section } from '../components/section'
import { DiagramContainer, DiagramItem, ItemTitle, ItemText } from '../components/section-diagram'
import { SectionNavigator } from '../components/section-navigator'
import { SectionSpaceLarge, SectionSpaceMedium } from '../components/section-space'
import { SectionTextExtraLarge, SectionTextMedium, SectionTextSmall } from '../components/section-text'
import { SectionTitle } from '../components/section-title'
import { usePageQuery } from '../generated/graphql'

const Outer = styled.div``

type KosodatePageProps = {

}
export const KosodatePage: FunctionComponent<KosodatePageProps> = () => {
  const putyQuery = usePageQuery({
    variables: {
      slug: 'kosodate-puty'
    }
  })
  const apreQuery = usePageQuery({
    variables: {
      slug: 'kosodate-apre'
    }
  })
  const babyQuery = usePageQuery({
    variables: {
      slug: 'kosodate-baby'
    }
  })
  const koaraQuery = usePageQuery({
    variables: {
      slug: 'kosodate-koara'
    }
  })
  const kidsQuery = usePageQuery({
    variables: {
      slug: 'kosodate-kids'
    }
  })
  return <Outer>
  <HeadBannar desktop={() => <BannerImage src="/images/header_05.jpg" />} mobile={() => <BannerImage src="/images/header_05_mobile.jpg" />}></HeadBannar>
  <ContentContainer>
    {/* <SectionNavigator labelMap={new Map([['concept', 'Concept'], ['courses', '各コース説明図']])} /> */}
    <Section id="concept">
      <SectionTitle>CONCEPT</SectionTitle>
      <SectionSpaceMedium />
      <DecoratedFrame leftTop="/images/dec_05_01.png" rightBottom="/images/dec_05_02.png">
        <AutoImage src="/images/img_08.jpg" mobileSrc="/images/img_08_mobile.jpg" />
      </DecoratedFrame>
      <SectionSpaceMedium />
      <SectionTextSmall>
        認定こども園ムロノキッズでは、<br />
        下記の通り地域の就園前親子に対して子育て支援や未就園児クラスを開放しています。<br />
        お子様の成長段階に合わせて月齢や年齢別、目的別のクラス運営をしていますので、<br />
        ご自身にあったクラスに気軽に足をお運びください。<br />
        セキュリティの関係上、事前登録が必要ですので、お問い合わせフォームより会員登録をお願いします。
      </SectionTextSmall>
    </Section>
    <Section id="courses">
      <DiagramContainer>
        <DiagramItem>
          <ItemTitle>プティ</ItemTitle>
          <ItemText dangerouslySetInnerHTML={{__html: putyQuery.data?.pageBy?.content ?? ''}}/>
        </DiagramItem>
        <DiagramItem>
          <ItemTitle>ムロノキッズBaby</ItemTitle>
          <ItemText dangerouslySetInnerHTML={{__html: babyQuery.data?.pageBy?.content ?? ''}}/>
        </DiagramItem>
        <DiagramItem>
          <ItemTitle>ムロノキッズ</ItemTitle>
          <ItemText dangerouslySetInnerHTML={{__html: kidsQuery.data?.pageBy?.content ?? ''}}/>
        </DiagramItem>
        <DiagramItem>
          <ItemTitle>コアラ組</ItemTitle>
          <ItemText dangerouslySetInnerHTML={{__html: koaraQuery.data?.pageBy?.content ?? ''}}/>
        </DiagramItem>
      </DiagramContainer>
    </Section>
    <BlogSection where={{categoryName: 'from'}} />
  </ContentContainer>
  </Outer>
}